import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@weezevent/nacre';
import Styles from '../../styles/minisite/blocks.module.css';
import { Trans } from 'react-i18next';

export default function AddBlock({ onClick }) {
    return (
        <div className={Styles['create-content']} onClick={onClick}>
            <Icon name="plus" />
            <Trans i18nKey="ticket.common.action.add" />
        </div>
    );
}

AddBlock.propTypes = {
    onClick: PropTypes.func.isRequired
};
